import { useEffect } from 'react';
import { profile } from './profile';

// Keep the browser tab title in sync with the current page.
export default function useTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · ${profile.name}` : profile.name;
  }, [title]);
}
